import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d1e009a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808B3RenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "1. 三角形的三条边与其对应角符号颜色的相同程度（左边对应右角符号，右边对应左角符号，底边对应顶角符号）；", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "2. 三角形中心圆圈的颜色；", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3. 按照这两个条件来又快又准的判别三角形的类型。", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "10", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "20", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "30", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "01", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "03", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "05", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "02", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "04", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "06", -1));
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "三条边与其对应角符号颜色的相同程度", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全不同", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全同", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "一同", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "三条边与其对应角符号颜色的相同程度", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全不同", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全不同", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全同", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "全同", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "一同", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "一同", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "中心圈颜色", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "blue"
  }
}, "蓝○", -1));
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "red"
  }
}, "红○", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "green"
  }
}, "绿○", -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "中心圈颜色", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "green"
  }
}, "绿○", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "red"
  }
}, "红○", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "blue"
  }
}, "蓝○", -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "green"
  }
}, "绿○", -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "red"
  }
}, "红○", -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12",
  style: {
    "color": "blue"
  }
}, "蓝○", -1));
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "三角形类型", -1));
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "10", -1));
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "20", -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "30", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "三角形类型", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "01", -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "02", -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "03", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "04", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "05", -1));
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "mb12"
}, "06", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_CirclePlusInTriangle = _resolveComponent("CirclePlusInTriangle");
  const _component_E808B3AnswerBtn = _resolveComponent("E808B3AnswerBtn");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString((($props.data[$props.data.length - 1].questionIndex + 1) / 4).toFixed(0)) + "组", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [$data.subject == 'E808B3' ? (_openBlock(), _createElementBlock("span", _hoisted_4, "我们将每个三角形，按照一定的规则进行分类，其分类规则是：")) : _createCommentVNode("", true), $data.subject == 'E808B4' ? (_openBlock(), _createElementBlock("span", _hoisted_5, "先将三角形补充完整，然后按照一定的规则进行分类，其分类规则是：")) : _createCommentVNode("", true), _hoisted_6, _hoisted_7, _hoisted_8]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "bothCenter flex flex-col"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "BRGGBRB"
          }), _hoisted_9]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "RGBRGBR"
          }), _hoisted_10]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "GBRRBGG"
          }), _hoisted_11]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "BRGGBRG"
          }), _hoisted_12]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "RGBRGBB"
          }), _hoisted_13]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "GBRRBGR"
          }), _hoisted_14]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "BRGGBRR"
          }), _hoisted_15]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "RGBRGBG"
          }), _hoisted_16]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
            colors: "GBRRBGB"
          }), _hoisted_17]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12,
      class: "flex items-center ft14"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "wd100"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26, _hoisted_27, _hoisted_28]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_hoisted_29, _hoisted_30, _hoisted_31, _hoisted_32, _hoisted_33, _hoisted_34, _hoisted_35, _hoisted_36, _hoisted_37, _hoisted_38, _hoisted_39]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 6,
          class: "bothCenter flex flex-col"
        }, {
          default: _withCtx(() => [_hoisted_40, _hoisted_41, _hoisted_42, _hoisted_43, _hoisted_44, _hoisted_45, _hoisted_46, _hoisted_47, _hoisted_48, _hoisted_49, _hoisted_50]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, q => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        class: "mt32 flex flex-col bothCenter",
        key: q.questionIndex
      }, {
        default: _withCtx(() => [_createVNode(_component_CirclePlusInTriangle, {
          colors: q.question
        }, null, 8, ["colors"]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "flex flex-col mt8 ft14"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, "正确答案:" + _toDisplayString(q.rightAnswer), 1), $props.review[q.questionIndex] ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            style: _normalizeStyle({
              color: $props.review[q.questionIndex].result ? 'green' : 'red'
            })
          }, "您的答案:" + _toDisplayString($props.review[q.questionIndex].answer), 5)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_E808B3AnswerBtn, {
          key: 1,
          onAnswer: v => $options.onAnswer(q.questionIndex, v)
        }, null, 8, ["onAnswer"]))]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })]);
}